import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, ValuesInterface } from "interface/fuelType";
import { StatusInterface } from "interface/common";

export const fuelTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFuelTypes: builder.query<ApiResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: API.GET_FUEL_TYPE,
        method: "GET",
        params,
      }),
      providesTags: ["FuelType"],
    }),
    getFuelTypeList: builder.query<
      ApiResponse,
      { [key: string]: string | number } | void
    >({
      query: (params) => ({
        url: API.GET_FUEL_TYPE_LIST,
        method: "GET",
        params: params || undefined,
      }),
      providesTags: ["FuelType"],
    }),
    createFuelType: builder.mutation<
      ApiResponse,
      { params: ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_FUEL_TYPE,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["FuelType"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create fuel type:", error);
        }
      },
    }),
    updateFuelType: builder.mutation<
      ApiResponse,
      { params: ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_FUEL_TYPE,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["FuelType"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update fuel type:", error);
        }
      },
    }),
    updateFuelTypeStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_FUEL_TYPE}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FuelType"],
    }),
    deleteFuelType: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_FUEL_TYPE}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FuelType"],
    }),
    bulkUpdateFuelTypeStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_FUEL_TYPE}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["FuelType"],
    }),
    bulkDeleteFuelTypes: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_FUEL_TYPE}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["FuelType"],
    }),
  }),
});

export const {
  useGetFuelTypesQuery,
  useGetFuelTypeListQuery,
  useCreateFuelTypeMutation,
  useUpdateFuelTypeMutation,
  useUpdateFuelTypeStatusMutation,
  useDeleteFuelTypeMutation,
  useBulkUpdateFuelTypeStatusMutation,
  useBulkDeleteFuelTypesMutation,
} = fuelTypeApi;
